import React, { memo } from "react";

const AppCompanyLogoIcon = ({ color = "#ffffff", ...props }) => {
	return (
		<svg {...props} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21,19V5c0,-1.1 -0.9,-2 -2,-2L5,3c-1.1,0 -2,0.9 -2,2v14c0,1.1 0.9,2 2,2h14c1.1,0 2,-0.9 2,-2z M8.9,13.98l1.98,2.39l2.87,-3.69c0.2,-0.26 0.59,-0.26 0.79,0.01l3.06,4.08c0.25,0.33 0.01,0.8 -0.4,0.8L6.02,17.58c-0.42,0 -0.65,-0.48 -0.39,-0.81l2.5,-3.2C8.32,13.24 8.73,13.23 8.9,13.98z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppCompanyLogoIcon);
